import api from '@pray/shared/utils/api';

export type SystemCheckSocialPost = {
  social_post_public_id: string;
  content_public_id: string;
  content_title: string;
  artist_name: string;
  artist_public_id: string;
  failed_reason: string | null;
  post_generated_at: string;
  updated_at: string;
};

export type SystemCheckSocialPostsResponse = {
  data: SystemCheckSocialPost[];
  pagination: {
    next_cursor: string | null;
    has_more: boolean;
    total_count: number;
  };
};

export type GetSystemCheckSocialPostsParams = {
  cursor?: string | null;
  limit?: number;
};

export async function getSystemCheckSocialPosts({
  cursor = null,
  limit = 50,
}: GetSystemCheckSocialPostsParams = {}): Promise<SystemCheckSocialPostsResponse> {
  const params: Record<string, string | number> = { limit };

  if (cursor) params.cursor = cursor;

  const url = '/web/studio/system-check/social-posts';
  const response = await api.executeGetRequest<{ data: SystemCheckSocialPostsResponse }>(url, params);

  return response.data.data;
}
